<template lang="pug">
.right_box_main 
    .card-box
        // 右边卡片
        .card-rb 
            el-card(:body-style="{ padding: '16px' }")
                .fisthang
                    el-form.demo-form-inline(:inline='true', :model='searchlist', size='mini')
                        //- el-form-item(label='上级类别:')
                        //-     el-select(v-model='searchlist.parentId', placeholder='--请选择--', style='width:130px')
                        //-         el-option(v-for='item in pTypes', :key='item.value', :label='item.label', :value='item.value')
                        el-form-item(label='类别名称:')
                            el-input(v-model='searchlist.name', placeholder='请输入', style='width:130px')
                        el-form-item
                          el-button(type='success', size='mini', @click='showDialogForm("","0")') 新增
                        el-form-item
                            el-button(type='primary', @click='getTypeList') 查询
                        el-form-item
                            el-button(type='info', @click='searchlistReset') 重置
                  
                    // <el-button type="danger" size="mini">导出Excel</el-button>
                    // 表格盒子
                    .table_card
                        el-table(:data='tableData', :header-cell-style="{ background: '#f8fafa' }", border='', size='mini', align='center', current-row-key='', highlight-current-row='')
                            // <el-table-column type="selection" align="center" width="100px"></el-table-column>
                            el-table-column(type='index', align='center', label='序号', width='50')
                            el-table-column(align='center', prop='name', label='类别名称')
                            el-table-column(align='center', prop='status', label='状态')
                                template(scope='scope')
                                    el-switch(v-model='scope.row.status', active-value='0', inactive-value='1', @change='changeStatus(scope.row)')
                            el-table-column(align='center', label='操作', fixed='right')
                                template(slot-scope='scope')
                                    el-tooltip.item(effect='light', content='查看', placement='top-start')
                                        button.iconfont.icon-chakan.tabBtn(@click='Look(scope.row.id)')
                                    el-tooltip.item(effect='light', content='编辑', placement='top-start')
                                        button.iconfont.icon-bianji3.tabBtn(@click='editLook(scope.row.id)')
                                    el-tooltip.item(effect='light', content='删除', placement='top-start')
                                        button.iconfont.icon-icon7.tabBtn(@click='delet(scope.row.id)')
                                    
                        // 分页功能
                        el-pagination(:page-size='10', layout='total, prev, pager, next, jumper', @current-change='handleCurrentChange', :total='pageConfig.total')
    // 弹出框新增
    el-dialog(:title='dialogTitle', :visible.sync='showadd', width='500px')
        el-form(ref='addform', :model='addform', :rules='rules', label-width='110px', size='mini')
            el-form-item(label='类别名称:', prop='name')
                el-input(v-model='addform.name', style='width: 300px;', :disabled='readyOnly==true')
            el-form-item(label='状态：', prop='status')
                el-radio-group(v-model='addform.status', @change='selectDisposeCode', :disabled='readyOnly==true')
                    el-radio(label='0') 启用
                    el-radio(label='1') 禁用
        .boontbtn
            el-button(type='primary', rows='4', size='small', style='margin: 0 30px', @click='addformClick',v-if='addsend==true') 保存
            el-button(type='primary', rows='4', size='small', style='margin: 0 30px', @click='editformClick',v-if='editsend==true') 修改
            el-button(type='info', size='small', @click='cleardata') 取消

</template>

<script> 
import { post } from "@/api/requrestHttp"; 

export default {
  data() {
    return {
      addsend:false,
      editsend:false,
      readyOnly: false,
      dialogTitle: "新增",
      filterText: "",
      searchlist: {
        name:''
      }, 
      //表格数据
      tableData: [],
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      // 新增弹出层
      showadd: false,
      addform: {},
      rules: {
        name: [
          { required: true, message: "请输入类别名称", trigger: "blur" }
        ], 
      }, 
    };
  }, 
  methods: {
    showDialogForm(){
      this.dialogTitle = "新增";
      this.showadd = true;
      this.editsend = false;
      this.addsend = true;
      this.readyOnly = false;
    },
    //解决select框无法选中的情况
    selectDisposeCode() {
      this.$forceUpdate();
    },
    //改变状态
    async changeStatus(cdata) {
      alert
      this.$confirm("此操作将改变该信息状态, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let params = cdata; 
        console.log(params);
        post("/admin/policyInformationType/info/updatePolicyInformationType", params).then((res) => { 
          console.log(res); 
          var msg = "状态";
          msg = msg + (cdata.status == "0" ? "启用" : "禁用");
          if (res.code == 200) {
            this.$message({
              message: msg + "成功",
              type: "success"
            });
          } else {
            console.log(res.message);
            this.$message({
              message: msg + "失败",
              type: "error"
            });
          }
        });  
      })
      .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }, 
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getList();
    },
    addformClick(){
      this.$refs.addform.validate((valid) => {
        if (valid) {
          post("/admin/policyInformationType/info/insertPolicyInformationType",{ 
            ...this.addform
          }).then(res => {
              console.log(res);  
              if(res.code == 200){
                this.$message({
                  message: "新增成功",
                  type: "success"
                });
                this.showadd = false;
                this.cleardata();
                this.getTypeList()
              }else{
                this.$message({
                  message:"新增失败",
                  type:"warning"
                })
              }
          })
        }
      })
    },
    editformClick(){
      this.$refs.addform.validate((valid) => {
        if (valid) { 
          post("/admin/policyInformationType/info/updatePolicyInformationType",{ 
            ...this.addform
          }).then(res => {
              console.log(res);  
              if(res.code == 200){
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.getTypeList()
                this.cleardata()
              }else{
                this.$message({
                  message:"修改失败",
                  type:"warning"
                })
              }
          })
        }
      })
    },
    cleardata(){
      this.searchlist = {};
      this.addform = {};
      this.showadd = false
    },
    searchlistReset(){
      this.searchlist = {};
      this.getTypeList()
    },
    Look(id){ 
      this.readyOnly = true;
      this.showadd = true; 
      this.editsend = false;
      this.addsend = false;
      post("/admin/policyInformationType/info/getPolicyInformationType",{
        id:id
      }).then(res => {
          console.log(this.readyOnly); 
          if (res.code == 200) {
            this.addform = res.content 
            this.getTypeList();
          } else {
            this.$message({
              message: "删除失败：" + res.message,
              type: "error"
            });
          }
          
      })
    },
    editLook(id){  
      this.readyOnly = false;
      this.showadd = true;
      this.editsend = true;
      this.addsend = false;
      post("/admin/policyInformationType/info/getPolicyInformationType",{
        id:id
      }).then(res => {
          console.log(res); 
          if (res.code == 200) {
            this.addform = res.content;
            this.getTypeList();
          } else {
            this.$message({
              message: "删除失败：" + res.message,
              type: "error"
            });
          }
          
      })
    },
    getTypeList(){
      post("/admin/policyInformationType/info/listPolicyInformationType",{
        pageSize:this.pageConfig.pageSize,
        pageNo:this.pageConfig.pageNo,
        ...this.searchlist
      }).then(res => {
          console.log(res); 
          this.tableData = res.content.list
      })
    },
    //删除操作 
    async delet(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => { 
        post("/admin/policyInformationType/info/deletePolicyInformation", {
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.getTypeList();
          }else{
            this.$message({ message: "删除失败", type: "error" });
          }
        });
      });
    }, 
  },
  mounted() {
    this.getTypeList(); 
  }
};
</script>

<style lang="less" scoped>
.filter-tree .el-input__inner {
  height: 30px;
  line-height: 30px;
}
//  包裹两个卡片的盒子
.card-box {
  display: flex;
  // 左边树状列表卡片
  .card-l {
    margin-left: 10px;
    width: 300px;
    overflow-x: auto;
  }
  // 右边卡片
  .card-rb {
    // width: calc(100% - 300px);
    // width: 100%;
  }
}
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
    }
    .tabBtn:nth-child(2) {
      color: #a1a1a1;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
    }
    .active_Btn {
      color: #ff04ed !important;
    }
  }
}
</style>
